import { chatTranslations } from '@/assets/locales/util/chat/chat.translations.en.ts';
import { toastsTranslations } from '@/assets/locales/util/toasts/toasts.translations.en.ts';
import { UtilsTranslation } from '@/assets/locales/util/utils.translation.pl.ts';
import { yearsMonthsTranslation } from '@/assets/locales/util/yearsMonths/yearsMonths.translation.en.ts';

export const utilsTranslation: UtilsTranslation = {
  actionRequired: 'Action required!',
  chat: chatTranslations,
  toasts: toastsTranslations,
  yearsMonths: yearsMonthsTranslation,
};
